import React from 'react';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';

export const SERVICE_DESK_PRODUCT = 'servicedesk';

export const defaultRedirectForSettings =
	(product: string) =>
	({ match }: RouteContext) => (
		<Redirect
			to={`/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`}
		/>
	);
